import { X } from "react-feather";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import DropboxPlayer from "../DropboxPlayer";
import "./Styles/Styles.scss";

const AlreadyVideoExistsMessage = ({
  open,
  handleClose,
  singleVideoDetail,
  videoDownloadErrorMessage,
}) => {
  const dropboxThumbnail = (
    <div className="videoWrapper">
      <DropboxPlayer
        styleClass={"videoFrame"}
        videoUrl={singleVideoDetail.video_url}
      />
    </div>
  );
  return (
    <Modal
      size="lg"
      isOpen={open}
      toggle={handleClose}
      className="VideoErrorMessage Step2FetchDetails VideoProcess modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X size={30} role="button" onClick={handleClose} />
      </ModalHeader>
      <ModalBody>
        <>
          <div className="d-flex justify-content-center">
            <div
              className="MainImageContainer"
              style={{ width: "588px", textAlign: "center" }}
            >
              {singleVideoDetail.platform === "localVideo" && (
                <video width={450} src={singleVideoDetail?.video_url} />
              )}
              {singleVideoDetail?.platform === "Dropbox" && dropboxThumbnail}
              {singleVideoDetail?.platform === "GoogleDrive" && (
                <img
                  src={
                    singleVideoDetail?.thumbnail_url ||
                    require("@src/assets/images/vyrill/default.png").default
                  }
                  onError={(e) => {
                    e.target.src =
                      require("@src/assets/images/vyrill/default.png").default;
                  }}
                  width={"100%"}
                />
              )}
            </div>
          </div>
          <div
            className="d-flex justify-content-center mt-3 mb-1"
            style={{ width: "713px" }}
          >
            <h2
              style={{
                color: "#E62580",
                fontSize: "36px",
                lineHeight: "63px",
              }}
            >
              {videoDownloadErrorMessage
                ? "This video cannot be uploaded!"
                : "This video already exist in the dashboard!"}
            </h2>
          </div>
          <div
            style={{
              textAlign: "center",
              color: "black",
              fontSize: "28px",
              lineHeight: "63px",
            }}
          >
            {videoDownloadErrorMessage
              ? "Please obtain editor permission from the video owner"
              : "Please upload a new video to continue."}
          </div>
        </>
      </ModalBody>
    </Modal>
  );
};

export default AlreadyVideoExistsMessage;
